var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEditing && !_vm.isDragging),expression:"isEditing && !isDragging"}],staticClass:"c-fl-frame__resize-handle",class:[_vm.orientation],on:{"mousedown":_vm.mousedown}})}
var staticRenderFns = []

export { render, staticRenderFns }